import { useMutation, useQueryClient } from 'react-query';
import { createReferral } from 'App/services/RMSService';

const useCreateReferralMutation = () => {
    const queryClient = useQueryClient();

    return useMutation(({ patientId, ...body }) => createReferral(patientId, body), {
        onSuccess: (_referral, variables) => {
            const queryPatientId = variables?.patientId;

            if (!queryPatientId) {
                return undefined;
            }

            return queryClient.refetchQueries(['patient', queryPatientId, 'referrals']);
        },
    });
};

export default useCreateReferralMutation;
